// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectCommunityFilterMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProjectCommunityFilterMetadataQuery = { __typename?: 'Query', projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
  > };


export const ProjectCommunityFilterMetadataDocument = gql`
    query ProjectCommunityFilterMetadata {
  projects(filter: {type: [Community]}) {
    id
    name
    market {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectCommunityFilterMetadataQuery__
 *
 * To run a query within a React component, call `useProjectCommunityFilterMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCommunityFilterMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCommunityFilterMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectCommunityFilterMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>(ProjectCommunityFilterMetadataDocument, options);
      }
export function useProjectCommunityFilterMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>(ProjectCommunityFilterMetadataDocument, options);
        }
// @ts-ignore
export function useProjectCommunityFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>;
export function useProjectCommunityFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectCommunityFilterMetadataQuery | undefined, ProjectCommunityFilterMetadataQueryVariables>;
export function useProjectCommunityFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>(ProjectCommunityFilterMetadataDocument, options);
        }
export type ProjectCommunityFilterMetadataQueryHookResult = ReturnType<typeof useProjectCommunityFilterMetadataQuery>;
export type ProjectCommunityFilterMetadataLazyQueryHookResult = ReturnType<typeof useProjectCommunityFilterMetadataLazyQuery>;
export type ProjectCommunityFilterMetadataSuspenseQueryHookResult = ReturnType<typeof useProjectCommunityFilterMetadataSuspenseQuery>;
export type ProjectCommunityFilterMetadataQueryResult = ApolloReactCommon.QueryResult<ProjectCommunityFilterMetadataQuery, ProjectCommunityFilterMetadataQueryVariables>;